import React from 'react';
import btnStyles from '../styles/button.module.scss'
import styles from '../styles/freeTrial.module.scss'
import AniLink from "gatsby-plugin-transition-link/AniLink";

function FreeTrial(props) {
    return (
     <div className={styles.freeTrial}>
        <div className={styles.freeTrial_btn}>
            <AniLink
              cover
              to="/ethos/"
              direction="right"
              className={btnStyles.button}>
              I'M READY
            </AniLink>
        </div>
    </div>
    )
}
export default FreeTrial 